import { ITeam, ITeamManager } from 'types/income';
import { Team, TeamManager } from './teams.types';
import { loaders } from './teams.loaders';

const convertTeamManager = (manager?: ITeamManager): TeamManager | null => {
  return manager
    ? {
        id: manager.id,
        name: manager.name,
      }
    : null;
};

const convertTeam = (team: ITeam): Team => {
  return {
    id: team.id,
    name: team.name,
    hidden: team.hidden,
    isEmpty: team.isEmpty,
    departmentId: team.departmentId,
    companyName: team.companyName,
    manager: convertTeamManager(team.manager),
  };
};

const convertTeams = (teams: ITeam[]): Team[] => {
  return teams.map(convertTeam);
};

export const converters = {
  getTeams: ({ data }: Awaited<ReturnType<typeof loaders.getTeams>>) => {
    return convertTeams(data.data);
  },
};
